module.exports = __webpack_public_path__ + "static/media/icon_1.96800a5f.png";